import { render, staticRenderFns } from "./InspectionSettings.vue?vue&type=template&id=2582a460&"
import script from "./InspectionSettings.vue?vue&type=script&lang=js&"
export * from "./InspectionSettings.vue?vue&type=script&lang=js&"
import style0 from "./InspectionSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports